import Info from '../../ui-components/Info'

type ExitLoadAndTaxInfoProps = {
  isHighExposureFund: boolean
  isElss: boolean
  highExposureTransferAmount: number
  withdrawalAmount: number
  currentWealth: number
  isRegularFund?: boolean
}

export default function ExitLoadAndTaxInfo({
  isHighExposureFund,
  isElss,
  highExposureTransferAmount,
  withdrawalAmount,
  currentWealth,
  isRegularFund
}: ExitLoadAndTaxInfoProps) {
  return (
    <Info
      lineClassName='border-l-2 border-[#00661D]'
      className='mx-5'
      contentClassName='text-status-text-in-form text-sm'
    >
      {getExitLoadAndTaxContent(
        isHighExposureFund,
        isElss,
        highExposureTransferAmount,
        withdrawalAmount,
        currentWealth,
        isRegularFund
      )}
    </Info>
  )
}

function getExitLoadAndTaxContent(
  isHighExposureFund: boolean,
  isElss: boolean,
  highExposureTransferAmount: number,
  withdrawalAmount: number,
  currentWealth: number,
  isRegularFund = false
) {
  const defaultCopy = 'Our rebalancing recommendations already factor in exit load and tax liability.'
  const regularFundCopy = 'This rebalance aims to minimise the impact of exit load and STCG tax to keep it tax-efficient.'
  const copy2 =
    "Tax is computed only for the units that are currently available for withdrawal. Locked ELSS units can't be sold until their 3 - year period ends."
  const copy1 =
    'Tax is computed based on selling the oldest investments first. Please verify the exact tax details on your broker platform.'
  if (isRegularFund) {
    return regularFundCopy
  } else {
    if (isElss) {
    if (isHighExposureFund) {
      if (highExposureTransferAmount !== withdrawalAmount) {
        return copy2
      } else {
        return copy1
      }
    } else {
      if (currentWealth !== withdrawalAmount) {
        return copy2
      } else {
        return defaultCopy
      }
    }
  } else {
    if (isHighExposureFund) {
      return copy1
    } else {
      return defaultCopy
    }
  }
}
}
